import { type Context, createContext } from 'react';

/** Shares the row's measured layout with its action menu without another width observer. */
export const SessionListItemCompactContext: Context<boolean> = createContext(false);
